"use client";

import React from "react";
import { ProductCard } from "../shopCards/ProductCard";
import { usePWA } from "@/utlis/usePWA";
import { useIsMobile } from "@/utlis/useIsMobile";

export default function ProductGrid({
	gridItems = 4,
	allproducts,
}) {
	const isPWA = usePWA();
	const isMobile = useIsMobile();
	const isCompact = isPWA || isMobile;

	if (isCompact) {
		return (
			<>
				<style jsx>{`
					.pg-count {
						width: fit-content;
						margin: 0 auto 24px;
						font-size: 17px;
					}

					/* IMPORTANT:
					   Nu lăsăm grid-ul să întindă cardurile pe verticală. */
					.pg-grid {
						width: 100%;
						display: grid;
						grid-template-columns: repeat(2, minmax(0, 1fr));
						gap: 12px;
						align-items: start;
						align-content: start;
					}

					/* Fiecare celulă rămâne strict la înălțimea conținutului */
					.pg-grid-item {
						width: 100%;
						min-width: 0;
						height: fit-content;
						min-height: 0;
						align-self: start;
						display: block;
					}

					/*
					 * ProductCard poate avea CSS global cu height:100%,
					 * min-height sau flex-grow.
					 * Resetăm aici aceste comportamente doar în grid.
					 */
					.pg-grid-item :global(.card-product) {
						height: auto !important;
						min-height: 0 !important;
						align-self: flex-start !important;
					}

					.pg-grid-item :global(.card-product .card-product-wrapper) {
						height: auto;
						min-height: 0;
					}

					.pg-grid-item :global(.card-product .card-product-info) {
						height: auto;
						min-height: 0;
					}

					/*
					 * Foarte important dacă ProductCard folosește flex
					 * și împinge prețul în partea de jos cu margin-top:auto.
					 */
					.pg-grid-item :global(.card-product .price),
					.pg-grid-item :global(.card-product .price-wrap) {
						margin-top: 0;
					}

					@media (max-width: 380px) {
						.pg-grid {
							gap: 10px;
						}
					}
				`}</style>

				<div className='pg-grid'>
					{allproducts.map((elm, i) => (
						<div key={elm?.id || i} className='pg-grid-item'>
							<ProductCard product={elm} priority={i < 2} />
						</div>
					))}
				</div>
			</>
		);
	}

	return (
		<>
			<div
                    className="grid-layout wrapper-shop"
                    style={{
                         display: "grid",
                         gridTemplateColumns: `repeat(auto-fit, minmax(350px, 1fr))`,
                         gap: "20px",
                    }}
               >

				{/* card product 1 */}
				{allproducts.map((elm, i) => (
					<ProductCard product={elm} key={i} priority={i < 2} />
				))}
			</div>{" "}
		</>
	);
}
